import type { RouteRecordRaw } from "vue-router";

export const reportingRoutes: RouteRecordRaw = {
    path: '/reports',
    children: [
        //metrics
        {
            name: 'Service Metrics',
            path: 'service-metrics',
            component: () => import('./metrics/service-metrics/ServiceMetrics.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Patient Metrics - Summary',
            path: 'patient-metrics/summary',
            component: () => import('./metrics/patient-metrics/PatientMetrics.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Patient Metrics - Details',
            path: 'patient-metrics/details',
            component: () => import('./metrics/patient-metrics/PatientMetricsDetails.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Item Prep',
            path: 'item-prep',
            component: () => import('./metrics/item-prep/ItemPrep.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Volume Metrics',
            path: 'volume-metrics',
            component: () => import('./metrics/volume-metrics/VolumeMetrics.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Geographic Metrics',
            path: 'geo',
            component: () => import('./metrics/geo-metrics/GeoMetrics.vue'),
        },
        {
            name: 'Executive Director Metrics',
            path: 'executive-director-metrics',
            component: () => import('./metrics/executive-director-metrics/ExecutiveDirectorMetrics.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Partnership Metrics',
            path: 'partnership-metrics',
            component: () => import('./metrics/partnership-metrics/PartnershipMetrics.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'No Shows',
            path: 'no-shows',
            component: () => import('./metrics/no-shows/NoShows.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Drug Log (Inactive)',
            path: 'drug-log',
            component: () => import('./metrics/drug-log/DrugLog.vue'),
        },
        {
            name: 'Rabies Export',
            path: 'rabies',
            component: () => import('./metrics/rabies/RabiesReport.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Death',
            path: 'death',
            component: () => import('./metrics/death/DeathReport.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Recheck',
            path: 'recheck',
            component: () => import('./metrics/recheck/RecheckReport.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Donations Reports',
            path: 'donations',
            component: () => import('./metrics/donations/DonationsReport.vue'),
            meta: { defaultLayout: true }
        },
        //custom reports
        {
            name: 'Custom reports',
            path: 'custom-reports',
            component: () => import('./custom-reports/CustomReports.vue'),
        },
        //master report
        {
            name: 'Master Report',
            path: 'master-report',
            component: () => import('./master-report/MasterReport.vue'),
            meta: { defaultLayout: true }
        },
        //microchip
        {
            name: 'Microchip Export',
            path: 'microchip-export',
            component: () => import('./microchip-export/MicrochipExport.vue'),
            meta: { defaultLayout: true }
        },
        //subsidies
        {
            name: 'Subsidies - Summary',
            path: 'subsidies/summary',
            component: () => import('./subsidies/SubsidiesSummary.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Subsidies - History',
            path: 'subsidies/history',
            component: () => import('./subsidies/SubsidiesHistory.vue'),
            meta: { defaultLayout: true }
        },
        //special reports / petsmart
        {
            name: 'PetSmart Report',
            path: 'special-reports/petsmart',
            component: () => import('./special-reports/PetSmartReport.vue'),
        },
        //productivity
        {
            name: 'Appointment Scheduling',
            path: 'productivity/appointment-scheduling',
            component: () => import('./productivity/AppointmentScheduling.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Priority Appointments',
            path: 'productivity/priority-appointments',
            component: () => import('./productivity/PriorityAppointments.vue'),
            meta: { defaultLayout: true }
        },
        //clinic custom report
        {
            name: 'Clinic Custom Report',
            path: 'clinic-custom-report/:id',
            component: () => import('./clinic-custom-reports/ClinicCustomReports.vue'),
            meta: { defaultLayout: true }
        }
    ]
}
